(() => {
  const root = document.querySelector('[data-sd-ai]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const endpoint = root.dataset.endpoint;
  const contactUrl = root.dataset.contactUrl || '/pages/contact';
  const panel = root.querySelector('[data-sd-ai-panel]');
  const openButton = root.querySelector('[data-sd-ai-open]');
  const closeButton = root.querySelector('[data-sd-ai-close]');
  const messages = root.querySelector('[data-sd-ai-messages]');
  const starters = root.querySelector('[data-sd-ai-starters]');
  const form = root.querySelector('[data-sd-ai-form]');
  const input = root.querySelector('[data-sd-ai-input]');
  const sendButton = root.querySelector('[data-sd-ai-send]');
  let conversationId = null;
  let busy = false;

  try { conversationId = sessionStorage.getItem('sdAdvisorConversation'); } catch (_) {}

  const scrollMessages = () => { messages.scrollTop = messages.scrollHeight; };
  const validSweatDecksUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.protocol === 'https:' && (url.hostname === 'sweatdecks.com' || url.hostname === 'www.sweatdecks.com') ? url : null;
    } catch (_) { return null; }
  };

  const appendSafeText = (parent, rawText) => {
    const text = String(rawText || '')
      .replace(/\*\*/g, '')
      .replace(/\[([^\]]+)\]\((https:\/\/(?:www\.)?sweatdecks\.com\/[^)]+)\)/gi, '$1: $2');
    const urlPattern = /https:\/\/(?:www\.)?sweatdecks\.com\/[^\s)\]]+/gi;
    let index = 0;
    for (const match of text.matchAll(urlPattern)) {
      parent.append(document.createTextNode(text.slice(index, match.index)));
      const url = validSweatDecksUrl(match[0]);
      if (url) {
        const link = document.createElement('a');
        link.href = url.toString();
        link.textContent = 'View source';
        parent.append(link);
      } else parent.append(document.createTextNode(match[0]));
      index = match.index + match[0].length;
    }
    parent.append(document.createTextNode(text.slice(index)));
  };

  const addMessage = (text, role = 'assistant') => {
    const item = document.createElement('div');
    item.className = `sd-ai__message sd-ai__message--${role}`;
    const paragraph = document.createElement('p');
    if (role === 'assistant') appendSafeText(paragraph, text);
    else paragraph.textContent = text;
    item.append(paragraph);
    messages.append(item);
    scrollMessages();
    return paragraph;
  };

  const addStatus = (text) => {
    const status = messages.querySelector('[data-sd-ai-status]') || document.createElement('div');
    status.className = 'sd-ai__message sd-ai__message--status';
    status.dataset.sdAiStatus = '';
    status.textContent = text;
    if (!status.parentNode) messages.append(status);
    scrollMessages();
  };
  const clearStatus = () => messages.querySelector('[data-sd-ai-status]')?.remove();

  const showProducts = (products) => {
    const list = document.createElement('div');
    list.className = 'sd-ai__products';
    for (const product of (Array.isArray(products) ? products.slice(0, 3) : [])) {
      const url = validSweatDecksUrl(product.url);
      if (!url) continue;
      const card = document.createElement('a');
      card.className = 'sd-ai__product';
      card.href = url.toString();
      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = product.image_alt || product.title || '';
        image.width = 70;
        image.height = 70;
        image.loading = 'lazy';
        card.append(image);
      }
      const body = document.createElement('div');
      body.className = 'sd-ai__product-body';
      const brand = document.createElement('p');
      brand.className = 'sd-ai__product-brand';
      brand.textContent = product.vendor || 'SweatDecks';
      const title = document.createElement('p');
      title.className = 'sd-ai__product-title';
      title.textContent = product.title || 'View product';
      const meta = document.createElement('p');
      meta.className = 'sd-ai__product-meta';
      meta.textContent = [product.price, product.available ? 'Available' : 'Availability not confirmed'].filter(Boolean).join(' · ');
      body.append(brand, title, meta);
      card.append(body);
      list.append(card);
    }
    if (list.children.length) messages.append(list);
    scrollMessages();
  };

  const showFallback = () => {
    const paragraph = addMessage('The AI advisor is temporarily unavailable. You can still find matching saunas or send your question to our team.');
    const finder = document.createElement('a');
    finder.href = '/pages/sauna-finder';
    finder.textContent = ' Use the Sauna Finder';
    const contact = document.createElement('a');
    contact.href = contactUrl;
    contact.textContent = ' Ask a specialist';
    paragraph.append(finder, document.createTextNode(' | '), contact);
  };

  const setOpen = (open) => {
    panel.hidden = !open;
    openButton.setAttribute('aria-expanded', String(open));
    if (open) window.setTimeout(() => input.focus(), 0);
    else openButton.focus();
  };

  const handleEvent = (event, state) => {
    if (event.type === 'conversation') {
      conversationId = event.conversation_id;
      try { sessionStorage.setItem('sdAdvisorConversation', conversationId); } catch (_) {}
    } else if (event.type === 'status') {
      addStatus(event.message || 'Checking…');
    } else if (event.type === 'products') {
      clearStatus();
      showProducts(event.products);
      state.hadOutput = true;
    } else if (event.type === 'text') {
      clearStatus();
      if (!state.paragraph) state.paragraph = addMessage('');
      state.text += event.text || '';
      state.hadOutput = true;
      state.paragraph.replaceChildren();
      appendSafeText(state.paragraph, state.text);
      scrollMessages();
    } else if (event.type === 'error') {
      clearStatus();
      showFallback();
      state.hadOutput = true;
    }
  };

  const submit = async (text) => {
    const question = String(text || '').trim();
    if (!question || busy) return;
    busy = true;
    sendButton.disabled = true;
    starters.hidden = true;
    addMessage(question, 'user');
    input.value = '';
    addStatus('Checking current SweatDecks information…');
    const state = { paragraph: null, text: '', hadOutput: false };
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: question,
          conversation_id: conversationId,
          context: { path: location.pathname }
        })
      });
      if (!response.ok || !response.body) throw new Error('Advisor unavailable');
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const frames = buffer.split('\n\n');
        buffer = frames.pop() || '';
        for (const frame of frames) {
          const line = frame.split('\n').find((part) => part.startsWith('data: '));
          if (!line) continue;
          try { handleEvent(JSON.parse(line.slice(6)), state); } catch (_) {}
        }
      }
      clearStatus();
      if (!state.hadOutput) showFallback();
    } catch (_) {
      clearStatus();
      showFallback();
    } finally {
      busy = false;
      sendButton.disabled = false;
      input.focus();
    }
  };

  openButton.addEventListener('click', () => setOpen(panel.hidden));
  document.querySelectorAll('[data-sd-ai-external-open]').forEach((button) => {
    button.addEventListener('click', () => setOpen(true));
  });
  closeButton.addEventListener('click', () => setOpen(false));
  form.addEventListener('submit', (event) => { event.preventDefault(); submit(input.value); });
  starters.addEventListener('click', (event) => {
    const button = event.target.closest('[data-prompt]');
    if (button) submit(button.dataset.prompt);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) setOpen(false);
  });
})();
